import React, {useContext, useState} from 'react';
import axios from "../../../helpers/axios";
import _ from "lodash";
import serviceContext from "./serviceContext";

const GoogleItem = ({s,i,cb, type,buyer}) => {
  const [loading, setLoading] = useState(false)
  const [baseTitle, setBaseTitle] = useState(true)

  const checkGoogle = () =>{
    setLoading(true)
    const send = {identifier:_.trim(s.idInOneC), type, counterparty: buyer}
    if(s.id){
      send.id = s.id
    }
    axios.post('/api/racoon/sheetify/findZakup', send)
      .then(({data})=>{
        console.log("Data: ", data);
        if(data.tableRecord.length){
          cb(data)
        }else{
          cb(data.tableRecord)
          setBaseTitle(false)
          setTimeout(()=>{
            setBaseTitle(true)
          }, 4000)
        }
      })
      .finally(()=>setLoading(false))
  }
  const renderString = () =>{
    if(baseTitle){
      return <><i
        className={`fa fa-circle text-danger`} style={{marginRight:2}}/>
        Нет инфо - <span className={'pointer link-info'}
                         onClick={checkGoogle}>Получить</span></>
    } else {
      return <>Мы ничего не нашли в Google таблице</>
    }
  }
  return (
    <>
      №{i + 1} - {s.idInOneC}<br/>
      {!loading && s.tableRecord && s.tableRecord.length >0 ? s.tableRecord.map((row, i)=> {
          return <div key={i}>
            <div className={'d-flex justify-content-between'}>
              <div>{row.tableName}</div>
              <div>Строка {row.row}</div>
            </div>
            {row.discription}
            {i+1 === s.tableRecord.length ?<span className={'pointer link-info'} onClick={checkGoogle}> Обновить</span>:''}
          </div>
        }) :
        loading ? 'Загружаю данные...' : renderString()}
    </>

  );
};

export default GoogleItem;
